import React from 'react';
import { Chip } from '@material-ui/core';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

export type StatusBadgeProps = {
  status: 'registering' | 'registered' | 'calling' | 'connected' | 'ended' | 'failed';
  className?: string;
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    base: {
      fontWeight: 500,
    },
    calling: {
      backgroundColor: '#FFF8E1',
      color: '#795548',
    },
    connected: {
      backgroundColor: '#4CAF50',
      color: '#fff',
    },
    ended: {
      backgroundColor: '#9E9E9E',
      color: '#fff',
    },
  })
);

const StatusBadge: React.FC<StatusBadgeProps> = ({ status, className }) => {
  const classes = useStyles();

  const getClassByStatus = () => {
    switch (status) {
      case 'calling':
        return classes.calling;
      case 'connected':
        return classes.connected;
      case 'ended':
        return classes.ended;
      default:
        return '';
    }
  };

  return (
    <Chip
      className={`${classes.base} ${getClassByStatus()} ${className ?? ''}`}
      label={status.toUpperCase()}
      size="small"
      aria-label={`Status: ${status}`}
    />
  );
};

export default StatusBadge;